import React, { useState, useEffect } from 'react';
import { Card, Icon } from 'antd';

import Description from 'components/Description/Description';

import BungalowSemiDImage from './../../images/register-property-bungalow-semiD.png';
import CondoApartmentServiceApartmentImage from './../../images/register-property-condo-apartment-serviceApartment.png';
import LandedTerraceServiceResidentialImage from './../../images/register-property-landed-terrace-serviceResidential.png';
import ResortBudgetHotelTownhouseImage from './../../images/register-property-resort-budgetHotel-townhouse.png';
import SofoSohoImage from './../../images/register-property-sofo-soho.png';

const PropertyCard = ({
  propertyName,
  propertyAddress,
  propertyType,
  className,
  onDeleteClick,
  onEditClick,
  shouldHideEdit,
  listAllPropertyTypes,
  ...props
}) => {
  const [imageSrc, setImageSrc] = useState('');

  const imageSources = {
    [listAllPropertyTypes.BUNGALOW.code]: BungalowSemiDImage,
    [listAllPropertyTypes.SEMID.code]: BungalowSemiDImage,
    [listAllPropertyTypes.CONDOMINIUM.code]: CondoApartmentServiceApartmentImage,
    [listAllPropertyTypes.APARTMENT.code]: CondoApartmentServiceApartmentImage,
    [listAllPropertyTypes.SERVICE_APARTMENT.code]: CondoApartmentServiceApartmentImage,
    [listAllPropertyTypes.LANDED.code]: LandedTerraceServiceResidentialImage,
    [listAllPropertyTypes.TERRACE.code]: LandedTerraceServiceResidentialImage,
    [listAllPropertyTypes.SERVICE_RESIDENTIAL.code]: LandedTerraceServiceResidentialImage,
    [listAllPropertyTypes.RESORT.code]: ResortBudgetHotelTownhouseImage,
    [listAllPropertyTypes.BUDGET_HOTEL.code]: ResortBudgetHotelTownhouseImage,
    [listAllPropertyTypes.TOWNHOUSE.code]: ResortBudgetHotelTownhouseImage,
    [listAllPropertyTypes.SOFO.code]: SofoSohoImage,
    [listAllPropertyTypes.SOHO.code]: SofoSohoImage
  };

  useEffect(() => {
    const src = imageSources[propertyType];

    setImageSrc(src);
  }, [propertyType, imageSources]);

  return (
    <Card
      bodyStyle={{ minHeight: 235 }}
      cover={<img alt="property" src={imageSrc} />}
      actions={
        shouldHideEdit
          ? [<Icon type="delete" onClick={onDeleteClick} />]
          : [<Icon type="edit" onClick={onEditClick} />, <Icon type="delete" onClick={onDeleteClick} />]
      }
    >
      <Description size="regular">{propertyName}</Description>
      <Description size="small">{propertyAddress}</Description>
    </Card>
  );
};

export default PropertyCard;
